import { SagasFactory } from '../factories/sagas.factory';
import { UsersActions } from './users.actions';
import usersActionTypes from './users.actionTypes';
import { UsersApi } from './users.api';

const factory = new SagasFactory('users', 'users', UsersApi, UsersActions, usersActionTypes);
export const UsersSagas = factory.getSagas();
